import { RoomContextId, roomContextId, RoomPid, roomPid } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomJoinCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomJoinCmd.validationSchema()
  );

  constructor(readonly value: RoomJoinCmmdRaw) {
    JsonSchemaValidator.assert(RoomJoinCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "roomContextId"],
      properties: {
        roomContextId,
        roomId: roomPid
      },
      additionalProperties: false
    };
  }
}

interface RoomJoinCmmdRaw {
  roomContextId: RoomContextId;
  roomId: RoomPid;
}
